import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { Component, OnInit, Injector } from '@angular/core';
import { DconAuthComponent } from '../../config/dcon-authorization.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../../config/data.service';
import { LegacyExtractService } from '../../services/legacy-extract-services.service';
import { AlertPopupComponent } from 'src/app/shared/components/alert-popup/alert-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dcon-main',
  templateUrl: './dcon-main.component.html',
  styleUrls: ['./dcon-main.component.scss'],
  providers: [DconAuthComponent],
})
export class DConComponent implements OnInit {
  public backcolor: string = '#FFFFFF';
  public iconbackcolor: string = '#75787B';
  public dropdownNotClicked = true;
  public btnDisabled = true;
  public projid: any = 'null';
  public imgDisabled = true;
  public prjSelected = false;
  public authProjectID: any;
  public headingColor: string = '#75787B';
  public textColor: string = '#75787B';
  public fetchProject = [];
  public playvid = false;
  loggedUser: string;
  showDropdown: boolean = false;
  public str: string;
  userId: any;
  projiddata: any;
  dropdownDisabled: boolean = true;
  routeParams: any;
  authProjectIDSubject: any;
  counter: number;
  urlUserId: any;
  paramsObj: any = {};
  showerror: boolean = false;
  isTrainStopUrl: boolean = false;
  showLegacy: boolean = false;
  selectedFile: File | null = null;
  searchIdentifier: string = '';
  uploadedFilesData: any = {}; // Store uploaded JSON data
  modalOpen: boolean = false; // Track modal state
  uploadMessage: string | null = null; //File Upload message
  showConfigBuild: boolean = DconConfigAPI.USE_CONFIGBUILD_FEATURE;

  constructor(
    public dialog: MatDialog,
    private _data: DataService,
    private DconAuth: DconAuthComponent,
    public celService: LegacyExtractService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private injector: Injector,
    private router: Router
  ) {
    const params = JSON.parse(sessionStorage.getItem('queryParams'));

    if (params != null) {
      const paramKeys = Object.keys(params);
      this.paramsObj[paramKeys[0]] = params[paramKeys[0]];
      this.paramsObj[paramKeys[1]] = params[paramKeys[1]];
      if (params[paramKeys[0]] != null && params[paramKeys[0]] !== undefined) {
        this.projiddata = params[paramKeys[0]];
        this.urlUserId = params[paramKeys[1]];
        this._data.setisTrainStopUrl(true);
        this.isTrainStopUrl = true;
      }
    } else {
      this._data.isTrainStopUrl = false;
      sessionStorage.setItem('isTrainStopUrl', 'false');
    }
  }

  ngOnInit() {
    this.counter = 0;
    this._data.projectID = '';
    this._data.tMenuDisabled = true;
    this._data.authProjectID.subscribe((res) => {
      if (res != null || res != undefined) {
        if (res?.items?.length > 0) {
          this.showDropdown = true;
          this.dropdownDisabled = false;
        }
        this.fetchProject = [];
        this._data.count = 0;
        res?.items?.forEach((element) => {
          this.str = element.securitygroup;
          this.fetchProject.push(element);
        });

        if (this._data.isTrainStopUrl) {
          this.showerror = false;
          const loggedUser = this._data.loggedUserId.substr(
            0,
            this._data.loggedUserId.length - 13
          );
          if (this.urlUserId === loggedUser) {
            let projData = [];
            projData = this.fetchProject.filter(
              (proj) => proj.projectid === this.projiddata
            );
            if (projData.length !== 0) {
              this.projid = projData[0];
              this.dropdownDisabled = true;
              if (this.counter === 0) {
                this.selectProject(this.projid);
              }
            } else {
              this.showDropdown = false;
              this.dropdownDisabled = true;
              this.showerror = true;
            }
          } else {
            this.showDropdown = false;
            this.dropdownDisabled = true;
            this.showerror = true;
          }
        } else {
          if (this.counter === 0) {
            if (this.fetchProject.length === 0) {
              this.showDropdown = false;
              this.alertPopUp(
                'Info Alert',
                'No Projects are tagged to the User'
              );
            }
          }
        }
        this.counter++;
        this.celService.projId = res;
        if (!this._data.isTrainStopUrl && this.fetchProject.length === 1) {
          this.projid = this.fetchProject[0];
          this.selectProject(this.projid);
          this.showLegacy = true;
        } else if (!this._data.isTrainStopUrl && this.fetchProject.length > 1) {
          const favouriteProject = localStorage.getItem(
            this._data.loggedUserId.split('@')[0]
          );
          if (favouriteProject) {
            const temp = this.fetchProject.find(
              (e) => e.projectid === favouriteProject
            );
            this.projid = temp ? temp : this.fetchProject[0];
            this.selectProject(this.projid);
            this.showLegacy = true;
          } else {
            this.projid = this.fetchProject[0];
            this.selectProject(this.projid);
            this.showLegacy = true;
          }
        }
      }
    });
  }
  

  selectProject(value) {
    this._data.apiCallInProgress = true;
    document.getElementById('overlay').style.display = 'block';
    if (value?.projectid !== null && value?.projectid !== undefined) {
      this._data.projectID = value.projectid;
      // Added during basic auth implementation
      this.projid = value;
      this._data.userRole = value.userrole;
      sessionStorage.setItem('projectId', value.projectid);
      localStorage.setItem(value.username, value.projectid);
      this.celService.projId = value.projectid;
      this.DconAuth.getUIPathCreds(value.projectid);
      this.iconbackcolor = '';
      this.headingColor = '';
      this.textColor = '';
      this.btnDisabled = false;
      this._data.LegacyExtract_Applicable.subscribe((res) => {
        this.showLegacy = res;
        sessionStorage.setItem('LegacyStatus', res);
      });
      this._data.setId = true;
      this._data.tMenuDisabled = false;
    } else {
      this._data.projectID = '';
      // Added during basic auth implementation
      this.projid = '';
      sessionStorage.setItem('projectId', value.projectid);
      this._data.apiCallInProgress = false;
      document.getElementById('overlay').style.display = 'none';
      this.iconbackcolor = '#75787B';
      this.textColor = '#75787B';
      this.headingColor = '#75787B';
      this.btnDisabled = true;
      this._data.count = 0;
      this._data.apiCallInProgress = false;
      document.getElementById('overlay').style.display = 'none';
    }
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById('overlay').style.display = 'block';
  }

  alertPopUp(type, mess) {
    const dialogRef = this.dialog.open(AlertPopupComponent, {
      width: '917px',
      height: '220px',
      data: {
        type: type,
        mess: mess,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
